import React, { useState } from 'react';
import { Select, Form, InputNumber, Checkbox, Card, notification } from 'antd';
import { DeleteOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';

const AmountInstance = ({
  path,
  outerName,
  name,
  restField,
  remove,
  moveUp,
  moveDown,
}) => {
  const form = Form.useFormInstance();
  const valueType = Form.useWatch(['discounts', outerName, 'amounts', name, 'valueType']);
  const amounts = Form.useWatch(['discounts', outerName, 'amounts']);
  const [hoveredDelete, setHoveredDelete] = useState(false);

  const actions = [
    <span
      style={{
        display: 'block',
        width: '100%',
        cursor: !moveUp ? 'default' : 'pointer',
      }}
      onClick={() => moveUp && moveUp()}
    >
      <UpOutlined
        style={{
          color: !moveUp ? '#ccc' : undefined,
        }}
      />
    </span>,

    <span
      style={{
        display: 'block',
        width: '100%',
        cursor: !moveDown ? 'default' : 'pointer',
      }}
      onClick={() => moveDown && moveDown()}
    >
      <DownOutlined
        style={{
          color: !moveDown ? '#ccc' : undefined,
        }}
      />
    </span>,

    <span
      style={{
        display: 'block',
        width: '100%',
        cursor: !remove ? 'default' : 'pointer',
      }}
      onMouseEnter={() => remove && setHoveredDelete(true)}
      onMouseLeave={() => remove && setHoveredDelete(false)}
      onClick={() => remove && remove(name)}
    >
      <DeleteOutlined
        style={{
          color: !remove
            ? '#ccc'
            : hoveredDelete
              ? '#ff4d4f'
              : undefined,
        }}
      />
    </span>,
  ];


  return (
    <Card
      size="small"
      actions={actions}
      style={{ marginBottom: 8 }}
    >
      <Form.Item
        {...restField}
        label="Value Type"
        name={[name, 'valueType']}
        rules={[{ required: true, message: "Please select a value type" }]}
        style={{ marginBottom: 16 }}
      >
        <Select placeholder="Select Value Type">
          <Select.Option value="percentage">Percentage</Select.Option>
          <Select.Option value="fixed">Fixed</Select.Option>
          <Select.Option value="product-price">Product Price</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item
        {...restField}
        label="Discount Value"
        name={[name, 'discountValue']}
        rules={[
          { required: true, message: "Please input a discount value" },
          { type: 'number', min: 0, message: "Discount value must be a positive number" },
          ...(valueType === "percentage" ? [{ type: 'number', max: 100, message: "Percentage cannot exceed 100%" }] : [])
        ]}
        style={{ marginBottom: 0 }}
      >
        <InputNumber
          placeholder="Enter Discount Value"
          style={{ width: "100%" }}
          prefix={["fixed", "product-price"].includes(valueType) ? "$" : null}
          suffix={valueType === "percentage" ? "%" : null}
        />
      </Form.Item>
      {(path === "/subsidies" || path === "/discount-reasons") && (
        <>
          <Form.Item
            {...restField}
            name={[name, 'upTo']}
            valuePropName="checked"
            style={{ marginBottom: 0, marginTop: 16 }}
          >
            <Checkbox
              style={{ marginBottom: 0 }}
              onChange={(e) => {
                if (!e.target.checked) {
                  return;
                }

                const anotherAmountIsVariable = amounts.some(
                  (amount, index) =>
                    index !== name && amount?.upTo === true
                );

                if (anotherAmountIsVariable) {
                  form.setFieldValue(
                    ['discounts', outerName, 'amounts', name, 'upTo'],
                    false
                  );

                  notification.warning({
                    message: "Variable Discount Amount",
                    description:
                      "You can only set one discount amount as variable.",
                  });
                }
              }}
            >
              Is the discount amount variable?
            </Checkbox>
          </Form.Item>

          {(["fixed", "product-price"].includes(valueType)) && (
            <>
              <Form.Item
                {...restField}
                name={[name, 'quantityInvariant']}
                valuePropName="checked"
                style={{ marginBottom: 0}}
              >
                <Checkbox>
                  Is the discount invariant to the number of hearing aids?
                </Checkbox>
              </Form.Item>
            </>
          )}
        </>
      )}
    </Card>
  )
};

export default AmountInstance;